import { graphqlClient } from '@/lib/graphql-client';
import {
  buildGetMySurveySubmissionsQuery,
  buildGetSurveyFormLookupQuery,
} from '../graphql/queries';
import { SUBMIT_SURVEY_MUTATION } from '../graphql/mutations';
import {
  AnswerValue,
  GetSurveySubmissionsParams,
  SurveyFormLookup,
  SurveySubmissionsPagingResult,
} from '../types/submission.types';

export const getMySurveySubmissions = async (
  params: GetSurveySubmissionsParams
): Promise<{ SurveySubmissions: SurveySubmissionsPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetMySurveySubmissionsQuery(filter, pageNo, pageSize, order),
  });
};

export const getSurveySubmissionById = async (
  itemId: string
): Promise<{ SurveySubmissions: SurveySubmissionsPagingResult }> =>
  graphqlClient.query({
    query: buildGetMySurveySubmissionsQuery({ ItemId: itemId }, 1, 1),
  });

export const getSurveyFormLookup = async (
  formId: string
): Promise<{ SurveyForms: { items: SurveyFormLookup[] } }> =>
  graphqlClient.query({
    query: buildGetSurveyFormLookupQuery({ ItemId: formId }, 1, 1),
  });

export const submitSurvey = async (params: { itemId: string; answers: AnswerValue[] }) => {
  const filter = JSON.stringify({ _id: params.itemId });
  return graphqlClient.mutate({
    query: SUBMIT_SURVEY_MUTATION,
    variables: {
      filter,
      input: {
        AnswersJson: JSON.stringify(params.answers),
        Status: 'Completed',
        SubmittedDateUtc: new Date().toISOString(),
      },
    },
  });
};
